<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{modalTitle}} </div>
        <div class="modal-body">
          <p>Veuillez vérifier les informations ci-dessous avant de valider.</p>
          <p>
              Si aucune information n'est renseignée, veuillez insérer la carte CPS de l'utilisateur remplacé pour remplir les champs ci-desssous si ceux-ci ne sont pas déjà remplis.
          </p>
          <div *ngIf="formGroup">
            <div>
              <frg-button class="lireCPS" backgroundColor="var(--darkest-primary)" (activated)="lireCPS()" >
                <div title="Lire sur la carte CPS">Lire ces informations sur la carte CPS</div>
              </frg-button>
            </div>
            <frg-form-input label="Identifiant National" id="identifiantNational"
              type="text" [formGroup]="formGroup" [control]="formGroup.get('identifiantNational')">
            </frg-form-input>
            <frg-form-input label="Identifiant National Structure" id="identifiantNationalStructure"
              type="text" [formGroup]="formGroup" [control]="formGroup.get('identifiantNationalStructure')">
            </frg-form-input>
            <frg-form-input label="Type Structure" id="typeStructure"
              type="ngSelect" [selectValue]="healthcareFacilityTypeSettings" [formGroup]="formGroup"
              [control]="formGroup.get('typeStructure')">
            </frg-form-input>
            <frg-form-input label="Numero de Facturation" id="numFacturation"
              type="text" [formGroup]="formGroup" [control]="formGroup.get('numFacturation')">
            </frg-form-input>
          </div>
          <frg-button class="validateButton" backgroundColor="var(--primary)" (activated)="validerForm()" >
              <div title="Activer le mode remplacement">Activer le mode remplacement</div>
          </frg-button>
        </div>
    </div>
</div>
<div class="modal-background"></div>
